import * as constants from './map/constants'

const getStorageMeta = (type) => constants.storageTypes.find(t => t.type === type) || {}

export const getStoragePrice = ({ size, type }) => Math.round((size * getStorageMeta(type).costPerSqft) / 5) * 5
export const getPlotPrice = ({ w, h }) => Math.round((w * h * 95) / 5) * 5
export const getPlotArea = ({ w, h }) => Math.round((w * h * 0.90) / 5) * 5
